<template>
  <div class="edt">
    <v-app-bar
      flat
      color="transparent"
      class="main-appbar"
    >
      <app-bar-nav-icon />
      <div class="d-flex align-center">
        <v-toolbar-title>
          <h1 class="headline font-weight-bold">{{ pageTitle }}
          </h1>
        </v-toolbar-title>
      </div>
      <v-spacer />
      <div>
        <v-btn
          color="primary"
          class="mr-4"
          medium
          @click="onCancel"
          :disabled="form.$busy"
          text
          style="text-transform: none;"
        >Cancel</v-btn>
        <v-btn
          color="primary"
          medium
          @click="onSave"
          :loading="form.$busy"
          style="text-transform: none;"
        >Save</v-btn>
      </div>
    </v-app-bar>
    <v-row class="px-4 py-4">
      <v-col
        lg="8"
        md="6"
        sm="12"
        xs="12"
      >
        <v-card
          outlined
          class="px-6 py-8"
        >
          <image-file-input-viewer
            label="Game Thumbnail"
            v-model="form.thumbnail"
          />
          <v-text-field
            class="mt-4"
            v-model="form.title"
            outlined
            label="Title"
            :error-messages="form.$getError('title')"
          />

          <!-- <v-text-field
            v-model="form.description"
            outlined
            label="Description"
          /> -->

          <v-text-field
            v-model="form.redirect_url"
            outlined
            label="URL"
            :error-messages="form.$getError('redirect_url')"
          />

          <!-- <league-selector-auto-complete
            :isGetID="true"
            :isNotMultiple="true"
            v-model="form.tag_id"
            tagType="all"
            @loadingState="state => loadingTags = state"
            :errorMessage="form.$getError('tag_id')"
          /> -->

        </v-card>
      </v-col>
      <v-col
        lg="4"
        md="6"
        sm="12"
      >
        <published-date-selector
          pageTitle="Start Date"
          v-model="form.start_date"
          :errorMessages="form.$getError('start_date')"
        />

        <published-date-selector
          class="mt-6"
          pageTitle="End Date"
          v-model="form.end_date"
          :errorMessages="form.$getError('end_date')"
        />
      </v-col>
    </v-row>
    <v-overlay
      absolute
      :value="updating"
    >
      <v-dialog
        v-model="updating"
        hide-overlay
        persistent
        width="300"
      >
        <v-card
          color="primary"
          dark
        >
          <v-card-text>
            {{ loading_message }}
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-overlay>
    <v-snackbar
      v-model="snackbar.show"
      right
      :color="snackbar.color"
    >
      {{ snackbar.message }}
      <v-btn
        text
        @click="snackbar.show = false"
      >OK</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import Form from '@/utils/form'
import get from 'lodash/get'
import head from 'lodash/head'
import replace from 'lodash/replace'
import FTPLiveGame from '@/models/FTPLiveGame'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'
import SocialSharingMetaTag from '@/components/SocialSharingMetaTag'
import ImageFileInputViewer from '@/components/ImageFileInputViewer'
import LeagueSelectorAutoComplete from '@/views/Home/Articles/shared/LeagueSelectorAutoComplete'
import PublishedDateSelector from '@/views/Home/Articles/shared/PublishedDateSelector'
import dates from '@/utils/dates'
import has from 'lodash/has'
import isNull from 'lodash/isNull'

const initialData = {
  title: null,
  description: null,
  redirect_url: null,
  start_date: null,
  end_date: null,
  tag_id: null,
  thumbnail: null
}

export default {

  components: {
    AppBarNavIcon,
    SocialSharingMetaTag,
    ImageFileInputViewer,
    LeagueSelectorAutoComplete,
    PublishedDateSelector
  },

  data () {
    return {
      loading: false,
      updating: false,
      loading_message: 'Loading',
      snackbar: {
        show: false,
        message: null,
        color: 'success'
      },
      loadingTags: false,
      form: new Form({
        ...initialData
      })
    }
  },
  props: {
    fTPLiveGame: {
      type: [FTPLiveGame, Object],
      default () {
        return {}
      }
    },
    pageTitle: {
      type: String,
      default: 'Free to Play Live Games'
    },
    redirectCancelTo: {
      type: [String, Object],
      default () {
        return {
          name: 'free-to-play-games'
        }
      }
    },
    redirectSaveTo: {
      type: [String, Object],
      default () {
        return {
          name: 'free-to-play-games'
        }
      }
    }
  },

  methods: {
    head,
    replace,
    onCancel () {
      this.$router.replace(this.redirectCancelTo)
    },

    async onSave () {
      try {
        this.form.$busy = true
        this.form.$clearErrors()
        const data = this.form.$data()
        this.$delete(data, 'tag_id')

        if (has(data, 'start_date') && !isNull(data.start_date)) {
          data.start_date = dates.localDateToUTC(data.start_date).format('YYYY-MM-DD HH:mm:ss')
        }

        if (has(data, 'end_date') && !isNull(data.end_date)) {
          data.end_date = dates.localDateToUTC(data.end_date).format('YYYY-MM-DD HH:mm:ss')
        }

        if (this.isModeUpdate) {
          data._method = 'put'

          if (data.thumbnail && data.thumbnail.id) { this.$delete(data, 'thumbnail') }
        }

        const fTPLiveGame = new FTPLiveGame(data)
        await fTPLiveGame.save()

        this.$router.replace(this.redirectSaveTo)
      } catch (error) {
        if (get(error, 'response.status') === 422) {
          if (get(error, 'response.data.errors') !== null) {
            this.form.$setErrors(get(error, 'response.data.errors'))
          } else {
            this.showSnackbar('Something went wrong.', 'error')
          }
        } else {
          this.showSnackbar(error, 'error')
        }
      } finally {
        this.form.$busy = false
      }
    },
    showSnackbar (message, color = 'success') {
      this.snackbar.message = message
      this.snackbar.show = true
      this.snackbar.color = color
    }

  },

  watch: {
    fTPLiveGame: {
      immediate: true,
      handler (val) {
        if (val) {
          this.form = new Form({
            ...initialData,
            ...val
          })
        }
      }
    }
  },

  computed: {
    isModeUpdate () {
      return get(this.form, 'id', null) !== null
    }
  }
}
</script>
